import { invokeHttp } from './api'

export const get = (id) => {
  return invokeHttp('/admin/patient/reservation/booking/preparecaregiverleave', { id })
}

export const leave = (id, dates, reasonTitle, reasonDetail) => {
  return invokeHttp('/admin/patient/reservation/booking/caregiverleave', {
    id,
    dates,
    reasonTitle,
    reasonDetail,
  })
}
